import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { CommonProvider } from '../../commonServices/common';
import { Apiurl } from '../../commonServices/route';
import { LoadingController, ModalController, NavParams } from '@ionic/angular';
import { Country } from 'src/data/country-location';
import { CompetitionInfo } from 'src/data/competition-data';
import { GameRoundInfo } from 'src/data/game-round';
import { PlayerService } from 'src/providers/player-service/player-service';

@Component({
  selector: 'app-country-list',
  templateUrl: './country-list.page.html',
  styleUrls: ['./country-list.page.scss'],
})
export class CountryListPage implements OnInit {
  constructor(
    public modalController: ModalController,
    public http: HttpClient,
    private navParams: NavParams,
    private loadingCtl: LoadingController,
    private playerService: PlayerService
  ) {
    this.competition = this.navParams.get('competition');
    this.gameRound = this.navParams.get('gameRound');
    this.headerName = this.navParams.get('headerName');
    this.excludeAll = this.navParams.get('excludeAll');
    this.countryList = this.navParams.get('countryList');
  }

  public competition: CompetitionInfo;
  public gameRound: GameRoundInfo;
  public headerName: string = 'Select preferred region';
  public countryList: Array<Country>;
  searchQuery: string;
  originalList: Array<Country>;
  excludeAll: boolean = false;

  ngOnInit() {
    // this.getCountrieList()
    if (this.countryList && this.countryList.length > 0) return;
    this.getCountry();
  }

  getInnerHTML() {
    let description =
      "<p><span style='background-color:#00FFFF'>Tournaments, electronic scorecards, analysis and more&hellip; Look no further! myGolf2u is a single place where you can find and register for any </span>competitions in your region, your favourite clubs or in the entire country on your phone or in this site.</p>";
    return description;
  }

  close() {
    this.modalController.dismiss(-999);
  }

  // ionViewDidLoad() {

  //   this.getCountry();
  // }

  countrySelected(country?: any) {
    // if (country === null) this.modalController.dismiss(-999);
    // else 
    this.modalController.dismiss(country);
  }

  async getCountry(cb?) {
    let loader = await this.loadingCtl.create({
      message: 'Getting Country List...',
      showBackdrop: false,
    });
    loader.present().then(() => {
      this.playerService.getCountryList().subscribe((data: Array<Country>) => {
        loader.dismiss().then(() => {
          this.countryList = data;
          this.originalList = data;
        });
      }),
        (error) => {
          loader.dismiss();
        },
        () => {
          loader.dismiss();
        };
    });
  }

  getFlagUrl(flagUrl: string) {
    if (flagUrl == null) return null;
    else {
      let flagIcon = flagUrl.split('/');

      return 'assets/img/flag/' + flagIcon[2];
    }
  }

  onSearchInput(event) {
    this.searchQuery = event?.target?.value;
    this.countryList = this.originalList;

    if (this.searchQuery.length == 0) return false;
    let _country: any;
    this.countryList = this.countryList.filter((country: any) => {
      // return country.name.toLowerCase().trim().includes(this.searchQuery.toLowerCase().trim())
      if (
        country.name
          .toLowerCase()
          .trim()
          .includes(this.searchQuery.toLowerCase().trim())
      )
        return 1;
      else if (
        country.id
          .toLowerCase()
          .trim()
          .includes(this.searchQuery.toLowerCase().trim())
      )
        return 1;
      // else if(country.sportCode.toLowerCase().trim().includes(this.searchQuery.toLowerCase().trim()))
      //     return 1
      else return 0;
    });
  }

  onSearchCancel() {
    this.countryList = this.originalList;
  }
}
